import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { deactivatePoshtaMarkers, fetchPoshtaMarkers, POSHTA_RESPONSE_STATUS } from '~/api/poshta';
import { isInGame } from '~/constants';
import { poshtaActions } from '~/store/slices/poshtaSlice';

import type { AppAsyncThunk } from '~/store';

export const getPoshtaMarkersThunk =
  (signal?: AbortSignal): AppAsyncThunk =>
  async (dispatch) => {
    try {
      const response = await fetchPoshtaMarkers(signal);

      if (!response?.result) {
        throw response;
      }

      dispatch(poshtaActions.setMarkers(response.result));
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        console.error('Failed get poshta markers', error);
      }
    }
  };

export const deactivatePoshtaMarkersThunk =
  (markerIds: string[]): AppAsyncThunk =>
  async (dispatch) => {
    const requestId = uuidv4();

    try {
      const response = await deactivatePoshtaMarkers(requestId, markerIds);

      if (!response || response.status !== POSHTA_RESPONSE_STATUS.OK) {
        throw response;
      }

      dispatch(poshtaActions.deactivateMarkers(markerIds));

      if (isInGame) {
        dispatch(poshtaActions.syncMarkersToClient());
      }
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        console.error('Failed get poshta markers', error);
      }
    }
  };
